import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Secure.module.scss';

export const SecureStepFour = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.secureLeftSection}>
        <span className={styles.secureStepLeft_1}>Secure Data with</span>
        <span className={styles.secureStepLeft_2}>FCE</span>
        <span className={styles.secureStepLeft_3}>Blockchain</span>
        <span className={styles.secureStepLeft_4}>and</span>
        <span className={styles.secureStepLeft_5}>Tokenization</span>
      </div>
    }
    rightContent={
      <div className={styles.secureStepContentWrapper}>
        <p style={{ marginBottom: 40 }}>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>
            Tokenization of companies and assets; (currently available for Swiss companies only)
          </div>
          Tokenization is the digitization of assets. On TransparenTerra, you can tokenize any class
          of assets – shares, stocks, products, intellectual property, real estate, etc.
        </p>
        <p>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>
            Notarization of documents and certificates
          </div>
          The NFT/NFA platform supports the owners of tokenized assets worldwide. Choose the best
          solution to digitize your company or products and get maximum benefits from the digital
          economy.
        </p>
      </div>
    }
  />
);
